import React from 'react';
import './QuestionCard.css';
import { ratingScale } from '../data/surveyData';

function QuestionCard({ question, selectedValue, onResponseChange, comment, onCommentChange, domain, subcategory, onGetInsights }) {

  const handleResponseClick = (value) => {
    if (selectedValue === value) {
      onResponseChange(question.id, undefined);
    } else {
      onResponseChange(question.id, value);
    }
  };

  return (
    <div className={`question-card ${selectedValue === undefined ? 'unanswered' : ''}`}>
      <div className="question-header">
        <div className="question-text">
          {question.text}
        </div>
        <button 
          className="info-icon-btn" 
          onClick={() => onGetInsights(question, domain, subcategory)}
          title="Get AI insights about this question"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18h6" />
            <path d="M10 22h4" />
            <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14" />
          </svg>
        </button>
      </div>
      <div className="rating-scale">
        {ratingScale.map((rating) => (
          <button
            key={rating.value}
            className={`rating-button ${selectedValue === rating.value ? 'selected' : ''}`}
            onClick={() => handleResponseClick(rating.value)}
          >
            <span className={`rating-label ${rating.label === 'Skip' ? 'skip-label' : ''}`}>
              {rating.label}
            </span>
          </button>
        ))}
      </div>
      <div className="comment-section">
        <label htmlFor={`comment-${question.id}`} className="comment-label">
          Optional Comments
        </label>
        <textarea
          id={`comment-${question.id}`}
          className="comment-input"
          placeholder="Add any additional comments here..."
          value={comment}
          onChange={(e) => onCommentChange(question.id, e.target.value)}
          rows="2"
        />
      </div>
    </div>
  );
}

export default QuestionCard;
